import {
  GET_ESTIMATED_PRICE_FAILURE,
  GET_ESTIMATED_PRICE_FILTERED_FAILURE,
  GET_ESTIMATED_PRICE_FILTERED_REQUEST,
  GET_ESTIMATED_PRICE_FILTERED_SUCCESS,
  GET_ESTIMATED_PRICE_REQUEST,
  GET_ESTIMATED_PRICE_SUCCESS,
  UPDATE_ESTIMATED_PRICE_FAILURE,
  UPDATE_ESTIMATED_PRICE_REQUEST,
  UPDATE_ESTIMATED_PRICE_SUCCESS,
} from "./ActionType";

const initialState = {
  estimatedPrice: [],
  estimatedPriceObj: {},
  updated: {},
  loading: false,
  error: null,
};

export const estimatedPriceReducer = (state = initialState, action) => {
  switch (action.type) {
    case [GET_ESTIMATED_PRICE_REQUEST, GET_ESTIMATED_PRICE_FILTERED_REQUEST]:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ESTIMATED_PRICE_SUCCESS:
      return {
        ...state,
        estimatedPrice: action.payload,
        loading: false,
        error: null,
      };
    case GET_ESTIMATED_PRICE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_ESTIMATED_PRICE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case UPDATE_ESTIMATED_PRICE_SUCCESS:
      return {
        ...state,
        updated: action.payload,
        loading: false,
        error: null,
      };

    case [UPDATE_ESTIMATED_PRICE_FAILURE, GET_ESTIMATED_PRICE_FILTERED_FAILURE]:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_ESTIMATED_PRICE_FILTERED_SUCCESS:
      return {
        ...state,
        estimatedPriceObj: action.payload,
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};
